import { render, staticRenderFns } from "./UploadFilesList.vue?vue&type=template&id=74af61eb&scoped=true&lang=html"
import script from "./UploadFilesList.vue?vue&type=script&lang=js"
export * from "./UploadFilesList.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesList.vue?vue&type=style&index=0&id=74af61eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af61eb",
  null
  
)

export default component.exports